module.exports = __webpack_public_path__ + "img/desserts.6d2c66f.jpg";